import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { NavController } from '@ionic/angular';
import decode from 'jwt-decode';

import { IResponseLoginAPI, IUser } from '@shared/interfaces/user.interface';
import { Observable } from 'rxjs';
import { Storage } from '@capacitor/storage';
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/app.reducers';
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from '@core/store/actions';
import { UserCredentialsLogin } from '../models/user-credentials-login.interface';
const URL = environment.apiBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  token: string;
  clerk: IUser;
  sortKeyUser: string;

  constructor(private http: HttpClient, private navController: NavController, private store: Store<AppState>) {}

  validateUserCredentials(dataAccessUser: UserCredentialsLogin): Observable<IResponseLoginAPI> {
    return this.http.post<IResponseLoginAPI>(`${URL}/autenticacion/v1/funcionarios/login`, dataAccessUser);
  }

  // TODO todo esto se debe mover al componente de sidebar
  async getUserBySortKey() {
    const currentTime = Date.now() / 1000;
    let tokenDecode = null;

    await this.loadToken();
    await this.loadDataUser();

    if (this.token) tokenDecode = decode(this.token);

    if (!this.token || !this.clerk || tokenDecode.exp < currentTime) {
      this.navController.navigateRoot('/login');
      this.navController.navigateRoot('/login');
    } else this.store.dispatch(LOGIN_SUCCESS({ user: this.clerk, token: this.token }));
  }

  // Cargar el token para validar que hay un usuario que inicio sesion con credenciales validas
  async loadToken() {
    const { value } = (await Storage.get({ key: 'token' })) || null;
    this.token = value;
    return this.token;
  }

  // Cargar la llave de ordenacion del usuario para obtener sus datos en caso que se pierdan por altualizacion del navegador
  async loadSortKeyUser() {
    const { value } = (await Storage.get({ key: 'user' })) || null;
    this.sortKeyUser = value;
  }

  // Cargar los datos del usuario que estan en el storage si la sesion se inicio correctamente
  async loadDataUser() {
    const storage = (await Storage.get({ key: 'user' })) || null;
    this.clerk = JSON.parse(storage.value);
  }

  validateToken() {
    return true;
  }
}
